import React from 'react'

/**
 * Displays the corresponding deduction rule where items and production rules
 * can be dropped.
 */
export function TagEarleyMoveUp() {
    return (<div className='deduction-rule'>
        <div className='rule-name'>MoveUp:</div>
        <div className='middle-rule-part'>
            <div
                className='antecedence'><span className={'unbreakable'}>[γ, dot · m, ra, i, j, k, l, 0]</span>
            </div>
            <hr/>
            <div
                className='consequence'><span className={'unbreakable'}>[γ, dot, rb, i, j, k, l, 0]</span>
            </div>
        </div>
        <div className='side-condition'><span className={'unbreakable'}>γ(dot · m + 1) is not defined</span></div>
    </div>)
}
